export const tokens = {
    size: {
        mobile: 40,
        desktop: 60,
    },
    iconSize: {
        mobile: 16,
        desktop: 20,
    },
};
